// eslint-disable-next-line no-restricted-imports
import { useIntl as useReactIntl } from 'react-intl';
// eslint-disable-next-line import/prefer-default-export
export function useIntl() {
  return useReactIntl();
}